/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:25]
Permissions to update outside the main branch: [false]
*/

import * as signalR from '@microsoft/signalr';
import useAuth from 'hooks/useAuth';
import { Notify } from 'providers/NotifyProvider';
import { useEffect, useState } from 'react';
import Environment from './environmentUtils';

const URL = Environment.GetSirnalRUrl();

const useSignalRConnection = (onNotifyEventReceived: (notify: Notify) => void) => {
    const { auth, isTokenValid } = useAuth();
    const [connection, setConnection] = useState<signalR.HubConnection | null>(null);

    useEffect(() => {
        if (auth?.userId) {
            if (!connection && isTokenValid())
                setConnection(
                    new signalR.HubConnectionBuilder()
                        .withUrl(URL)
                        .withAutomaticReconnect()
                        .withHubProtocol(new signalR.JsonHubProtocol())
                        .configureLogging(signalR.LogLevel.Critical)
                        .build()
                );
        } else {
            connection &&
                connection.state === 'Connected' &&
                connection.stop().then(() => console.log('Connection stopped!'));
            setConnection(null);
        }
    }, [auth]);

    useEffect(() => {
        if (connection && connection.state !== 'Connected') {
            connection
                .start()
                .then(() => console.log('Connection started!', auth?.userId))
                .catch((err) => document.write(err));

            connection.on('onConnected', () => {
                connection.invoke('AddClient', auth?.userId, 'AspUserId', 'BackOffice');
            });

            connection.on('notifyEvent', (notify: Notify) => {
                try {
                    onNotifyEventReceived(notify);
                } catch (err) {
                    console.error('SignalR Connection Error: ', err);
                }
            });
        }
    }, [connection]);
};

export default useSignalRConnection;
